export const isNullOrEmpty = (value: any) => {
    return value == null || value == undefined || value.toString().replaceAll(' ', '') == ''
}